export default __webpack_public_path__ + "static/10-1cf302b4b28cdf08d3ef4fec7d11691c.jpg";